import React from 'react'
import { useHistory } from 'react-router-dom'

// The wordmark split into its words (verbatim paths from US-full.svg / US-Early-full.svg,
// viewBox cropped to each word's bounding box).
import { ReactComponent as Up } from '../assets/svg/logo/up.svg'
import { ReactComponent as Strive } from '../assets/svg/logo/strive.svg'
import { ReactComponent as Education } from '../assets/svg/logo/education.svg'
import { ReactComponent as Early } from '../assets/svg/logo/early.svg'

// One logo in both sidebar states. The pieces are laid out at their wordmark positions;
// styles/SideBar.css translates and scales "Up" and the tagline onto their small-mark
// positions while the rail is collapsed and fades "strive" out, so the mark turns into
// the wordmark instead of crossfading with a second copy of itself. Geometry lives next
// to the --sb-logo-* tokens in the CSS.
const SidebarLogo = ({ primaryUI }) => {
    const history = useHistory()
    const Tagline = primaryUI ? Early : Education
    const svgProps = { 'aria-hidden': true, focusable: 'false' }

    return (
        <div className="sb-logo mt-6" data-variant={primaryUI ? 'early' : 'us'} onClick={() => history.push('/dashboard')}>
            <div className="sb-logo__frame">
                <span className="sb-logo__piece sb-logo__up">
                    <Up {...svgProps} />
                </span>
                <span className="sb-logo__piece sb-logo__strive">
                    <Strive {...svgProps} />
                </span>
                <span className="sb-logo__piece sb-logo__tagline">
                    <Tagline {...svgProps} />
                </span>
            </div>
        </div>
    )
}

export default SidebarLogo
